import { Component, OnInit } from '@angular/core';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { BreadcrumbService, ApplicationService } from '@picard/services-lib';
import { Title } from '@angular/platform-browser';
import { StorageConstants } from '@picard/shared-lib';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  termsPresent: boolean;
  termsHtml;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _breadcrumbService: BreadcrumbService, private _title: Title, private _applicationService: ApplicationService, private sanitizer: DomSanitizer) {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._breadcrumbService.setItems([{ label: 'Terms and Conditions', routerLink: '/terms' }]);
    if (this.docTheme) {
      this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Terms and Conditions`);

    if(this.preAuthenticationResponse.termsAndConditionsModel != null){
      this.termsPresent = true;
      this.termsHtml = this.sanitizer.bypassSecurityTrustHtml(this.preAuthenticationResponse.termsAndConditionsModel.description);
    }
  }
  //#endregion Functions
}
